import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);

function keyFor(slug) { return `pf_cart_${slug}`; }

export function CartProvider({ slug, children }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(keyFor(slug));
      setItems(raw ? JSON.parse(raw) : []);
    } catch { setItems([]); }
  }, [slug]);

  const persist = (next) => {
    setItems(next);
    localStorage.setItem(keyFor(slug), JSON.stringify(next));
  };

  const addItem = (line) => persist([...items, { ...line, cid: Math.random().toString(36).slice(2) }]);
  const updateQty = (cid, qty) =>
    persist(items.map((i) => (i.cid === cid ? { ...i, quantity: Math.max(1, qty) } : i)));
  const removeItem = (cid) => persist(items.filter((i) => i.cid !== cid));
  const clear = () => persist([]);

  const total = items.reduce((s, i) => s + i.line_total * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartCtx.Provider value={{ items, addItem, updateQty, removeItem, clear, total, count }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
